<template>
  <div class="zhanwei4"></div>
  <div class="container">
    <div class="form-group">
      <label for="visibility">显示设定</label>
      <el-select placeholder="请选择" id="visibility" v-model="option">
        <el-option label="非公开" value="非公开"></el-option>
        <el-option label="公开" value="公开"></el-option>
      </el-select>
    </div>
    <div class="info-group">
      <el-row>
        <el-col :span="12" v-if="form.id != null">
          <p><strong>正式版</strong></p>
          <!--          <p><a href="#">创作连结</a> | <a href="#">关卡 QR 码</a></p>-->
          <div class="qr-code">
            <vue-qr :text="qr_text" :size="200"></vue-qr>
          </div>
        </el-col>

        <el-col :span="12" class="info-details">
          <p><strong>地理位置:</strong> 任何地点 / 不限地区</p>
          <p v-if="form.createTime != null">
            <strong>建立时间:</strong> {{ form.createTime }}
          </p>
          <p>
            <strong v-if="form.releaseTime != null">发布时间:</strong>
            {{ form.releaseTime }}
          </p>
          <p>
            <strong>游玩状态:</strong>
            {{
              form.status == 0
                ? "审核中"
                : form.status == 1
                ? "已发布"
                : form.status == null
                ? "待发布"
                : "审核失败"
            }}
          </p>
          <p>
            <strong>版本号码:</strong>
            {{ form.version == null ? 0 : form.version }}
          </p>
          <p v-if="form.remark != null" style="color: red">
            <strong>备注:</strong> {{ form.remark }}
          </p>
        </el-col>
      </el-row>
    </div>
    <div class="button-group">
      <el-button type="primary" @click="releaseGame">发布新版本</el-button>
      <el-popover
        :width="150"
        popper-style="box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px;"
      >
        <template #reference>
          <div class="tiyan">
            <span>体验版</span>
            <span>
              <img
                style="width: 15px; height: 15px"
                src="https://img.51miz.com/Element/00/77/26/50/0ba4cf6c_E772650_6401310b.png"
                alt=""
              />
            </span>
          </div>
        </template>
        <template #default>
          <div
            class="demo-rich-conent"
            style="display: flex; gap: 16px; flex-direction: column"
          >
            <vue-qr :text="qr_text2" :size="600"></vue-qr>
          </div>
        </template>
      </el-popover>
    </div>
  </div>
</template>

<script lang="ts">
import { ElMessage, ElMessageBox } from "element-plus";
import { defineComponent } from "vue";
import vueQr from "vue-qr/src/packages/vue-qr.vue";

export default defineComponent({
  name: "release",
  data(): any {
    return {
      option: "",
      gameId: "",
      form: {
        id: "",
        publicStatus: 1,
        remark: null,
        gameLevelId: "",
        status: 0,
        version: 0,
        updateTime: "",
        releaseTime: "",
        createTime: "",
      },
      qr_text: "123",
      qr_text2: "123",
    };
  },
  components: {
    vueQr,
  },
  computed: {},
  watch: {},
  mounted() {
    const { id, detailId } = this.$route.params;
    this.gameId = id;
    this.initRelease(id);
  },
  methods: {
    initRelease(id: string) {
      this.$store
        .dispatch("game/getRelease", { releaseId: id })
        .then((res: any) => {
          res.remark = res.remark == "" ? null : res.remark;
          this.form = res;
          this.option = res.publicStatus == 1 ? "公开" : "非公开";

          this.qr_text = `${res.id}&${res.publicStatus}`;
          this.qr_text2 = `${res.id}&test`;
        })
        .catch((err: any) => {
          console.log(err);
        });
    },
    releaseGame() {
      ElMessageBox.confirm(
        "发布后，系统会自动建立资料包，使用者可从APP下载并开始体验！(资料包依大小可能会花费一定时间处理，请耐心等候，谢谢！",
        "确认发布",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          center: true,
        }
      )
        .then(() => {
          console.log(this.option);
          const a = this.option == "公开" ? 1 : 0;
          this.$store
            .dispatch("game/releaseGame2", {
              gameId: this.gameId,
              publicStatue: a,
            })
            .then((res: any) => {
              res.remark = res.remark == "" ? null : res.remark;
              this.form = res;
              this.option = res.publicStatus == 1 ? "公开" : "非公开";
            })
            .catch((err: any) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
  },
});
</script>

<style lang="less" scoped>
.container {
  max-width: 900px;
  margin: 50px auto;
  padding: 20px;
  font-family: "Helvetica Neue", Arial, sans-serif;
  background-color: #fff;
  border: 1px solid #e1e1e1;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.form-group {
  margin-bottom: 20px;
  text-align: left;
}

label {
  font-size: 16px;
  margin-right: 10px;
}

.el-select {
  width: 200px;
}

.info-group {
  margin-bottom: 20px;
}

.info-details {
  font-size: 16px;
  color: #555;
}

.info-details p {
  margin: 5px 0;
}

.info-details strong {
  color: #333;
}

.qr-code {
  margin-top: 10px;
}

.qr-code img {
  width: 150px;
  height: 150px;
}

.button-group {
  text-align: center;
  margin-bottom: 30px;
}

.el-button {
  width: 150px;
  text-transform: uppercase;
}

.footer {
  text-align: center;
}

.footer a {
  color: #3498db;
  text-decoration: none;
  font-size: 16px;
}

.footer a:hover {
  text-decoration: underline;
}

.tiyan {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}
</style>
